import React, { useEffect, useState } from "react";
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid, Typography
} from "@material-ui/core";
import SearchGrid from "../../../../../components/table/SearchGrid";
import useStyles from "./styles";
import { withSnackbar } from "../../../../../components/Message/Alert";
import { useHistory } from "react-router-dom";
import Loader from "../../../../../components/Loader/Loader";

import { PostDataAPI } from '../../../../../Services/APIService';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
//import DisbursementIcon from "../../../../../assets/img/icons/disbursement.svg";
import Authorization from "./components/Authorization/Authorization";
import AddDisbursement from "./components/addDisbursement/AddDisbursement";
import ViewDetails from "./components/viewDetails/ViewDetails";
import { ActionDialog } from "../../../../../components/ActionDialog/ActionDialog";
import { set } from "date-fns";
import ClearIcon from '@material-ui/icons/Clear';

function Payment({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;

    let history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [cashDisbursement, setCashDisbursement] = useState([
        { organizationName: 'Figgers foundation', programName: 'Think Tank1', promisedGrant: 1300, disbursedGrant: 1300, status: 0, Date: 'Oct 01, 2023' },
        { organizationName: 'Figgers foundation', programName: 'Think Tank2', promisedGrant: 1300, disbursedGrant: 1300, status: 0, Date: 'Oct 01, 2023' },
        { organizationName: 'Figgers foundation', programName: 'Think Tank3', promisedGrant: 1300, disbursedGrant: 1300, status: 0, Date: 'Oct 01, 2023' },
        { organizationName: 'Figgers foundation', programName: 'Think Tank4', promisedGrant: 1300, disbursedGrant: 1300, status: 0, Date: 'Oct 01, 2023' }

    ]);

    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState((prevState) => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback,
        }));
    };


    const handleSuccessClose = (message) => {
        handleDataRefresh()
        showMessage("Success", message, "success", 3000);
        closeCashDisbursement()
        loadAllCollection()
    }

    const donationStatusBoxes = [
        {
            value: 'Promised Grant',
            transactionStatus: 'Promised',
            numbers: '00',
            //icon: DisbursementIcon,
        },
        {
            value: 'Disbursed Grant',
            transactionStatus: 'Disbursed',
            numbers: '00',
            //icon: DisbursementIcon,
        },
    ]
    const getHeaderCount = (status) => {
        var count = 0;
        if (status == 'Promised') {
            count = cashDisbursement?.filter(t => t.transactionStatus == 'Promised').length
        } else if (status == 'Disbursed') {
            count = cashDisbursement?.filter(t => t.transactionStatus == 'Disbursed').length
        }
        return count;
    }


    const [isApproveClick, setIsApproveClick] = useState(false)
    const [isAuthorizationClick, setIsAuthorizationClick] = useState(false);


    const handleActionClick = (key, item) => {
        if (key == 'Details') {
            setIsApproveClick(true)
            setdisbursedId(item.disbursementId)
        }
        else if (key == 'delete') {
            deleteItem(item.disbursementId)
        }
        else {
            return ''
        }
    }
    const closeClick = () => {
        setIsAuthorizationClick(false);
        setIsApproveClick(false);

    };
    const [addNewCashDisbursement, setAddNewCashDisbursement] = useState(false
    );

    const addCashDisburs = () => {

        setAddNewCashDisbursement(true);
    };
    const closeCashDisbursement = () => {
        setAddNewCashDisbursement(false);
    };
    const handleClearInput = (name) => {
        setValue('');
        handleDataRefresh();
    };
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataRefresh()
        }
    }

    const [isDataRefresh, setIsDataRefresh] = useState(false);

    const handleDataRefresh = () => {
        setIsDataRefresh(prev => !prev);
    }

    const [disbursedData, setDisbursedData] = useState([]);

    const [searchFilter, setValue] = useState('');

    const loadAllCollection = () => {
        setIsLoading(true)
        var params = {
        }
        PostDataAPI("fdngrantdisbursement/loadGrid", params).then((result) => {
            console.log(result);
            // setIsLoading(false)
            if (result.success && result.data != null) {
                setDisbursedData(result.data)
                handleDataRefresh()
            } else {
                setDisbursedData([]);
            }
        });
    };

    const [disbursedId, setdisbursedId] = useState();

    const deleteItem = (id) => {
        let obj = {
            disbursementId: id
        }
        showActionDialog(
            "Are you sure you want to delete this record?",
            "confirm",
            function () {
                setIsLoading(true);

                PostDataAPI("fdngrantdisbursement/delete", obj).then((result) => {
                    if (result.success) {
                        showMessage("Success", "Disbursement deleted successfully", "success", 3000);
                        loadAllCollection();
                        handleDataRefresh()
                    } else {
                        showMessage("Error", result.message, "error", 3000);
                    }
                    setIsLoading(false);
                });
            }
        );
    };


    useEffect(() => {
        loadAllCollection()
    }, []);
    return (
        <>
            {isApproveClick ? <ViewDetails disbursedId={disbursedId} /> :

                <div>

                    <Grid container >
                        <div className={classes.gridHeader}>

                            <Typography variant="h5" color="initial" className={'HeaderText'}>
                                Cash Disbursement List
                            </Typography>
                            <div className={classes.SearchSec}>
                                <div item className={classes.gridActions}>
                                    <Button className={classes.changeBtn} onClick={() => addCashDisburs()}>Add New</Button>
                                </div>

                                <div itemclassName={classes.gridActions}>
                                    <InputBase
                                        value={searchFilter}
                                        placeholder="Search"
                                        className="grid-search-input"
                                        startAdornment={<SearchIcon />}
                                        onChange={handleSearch}
                                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                                    />

                                </div>
                            </div>

                        </div>
                    </Grid>


                    <Grid row className={classes.container}>
                        <SearchGrid
                            columns="cashDisbursement"
                            list={disbursedData}
                            isGridLoaded={isLoading}
                            noRecordMsg="No record exists."
                            filter={searchFilter}
                            Icon={true}
                            isUpdate={isDataRefresh}
                            isSearchAble={false}
                            onActionClick={handleActionClick}
                        />
                    </Grid>

                    {addNewCashDisbursement ? (
                        <AddDisbursement
                            isOpen={addCashDisburs}
                            handleClose={closeCashDisbursement}
                            handleSuccessClose={handleSuccessClose}
                        //   editProgram={editData} // Conditionally pass EditProgram
                        ></AddDisbursement>
                    ) : (
                        ""
                    )}

                    {isAuthorizationClick ? (
                        <Authorization
                            dialogOpenClose={handleActionClick}
                            handleClose={closeClick}
                        // handleSuccessClose={handleSuccessClose}
                        ></Authorization>
                    ) : (
                        ""
                    )}

                    <ActionDialog
                        type={actiondialogState.type}
                        message={actiondialogState.message}
                        actiondialogOpenClose={actiondialogState.showHide}
                        onSubmit={actiondialogState.onClickOk}
                        onCancel={() =>
                            setActionDialogState(prevState => ({
                                ...prevState, showHide: false
                            }))
                        }
                        onClose={() => setActionDialogState(prevState => ({
                            ...prevState, showHide: false
                        }))

                        }
                    />

                </div>

            }
        </>
    )
}
export default withSnackbar(Payment);